<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Show from "./show";
import { mapGetters } from "vuex";
import { VueContentLoading } from "vue-content-loading";

export default {
  page: {
    title: "أستمارة المشاركات الفنية",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Show, VueContentLoading },
  data() {
    return {
      title: "المسجلين في الاستمارة",
      items: [
        {
          text: "الرئيسيه",
          href: "/",
        },
        {
          text: "أستمارة المشاركات الفنية",
          active: true,
        },
      ],

      canShow: false,
      loadingContent: true,
    };
  },
  computed: {
    ...mapGetters("auth", ["getUser"]),
  },
  created() {
    this.canShow = this.getUser.hasAnyPermission(["show_artist", "show_details_artist"]);
  },
  mounted() {
    setTimeout(() => {
      this.loadingContent = false;
    }, 1000);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div v-if="!loadingContent" class="card-body">
            <Show v-if="canShow" />
          </div>

          <!-- loading content -->
          <div v-else>
            <vue-content-loading :rtl="true" :width="400" :height="110">
              <rect x="85" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="275" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="6" y="15" rx="1" ry="1" width="194" height="2" />
              <rect x="200" y="16" rx="1" ry="1" width="194" height="1" />

              <rect x="10" y="25" rx="1" ry="1" width="50" height="5" />
              <rect x="340" y="25" rx="1" ry="1" width="50" height="5" />

              <rect x="10" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="40" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="49" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="54" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="63" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="68" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="77" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="82" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="91" rx="1" ry="1" width="380" height="1" />
              <circle cx="340" cy="100" r="1" />
              <circle cx="350" cy="100" r="1" />
              <circle cx="363" cy="100" r="4" />
              <circle cx="376" cy="100" r="1" />
              <circle cx="386" cy="100" r="1" />
            </vue-content-loading>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
